import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import * as React from 'react';
import { useAppSelector } from '../../store/hook';
import { selectResult } from '../../store/result/resultSlice';
import { CurrentScenarioContext } from '../MultiScenario';
import { TableContainer } from '@mui/material';
import { Table } from '@mui/material';
import { TResult } from '../../shared/iResult';
import { useTranslation } from 'react-i18next';
import {
    TResultPhysicalData,
    horizontalDistanceBetweenPropellerAxisAndTheSlope,
    isOkMinimumRevetmentThickness,
    isOkMinimumRevetmentWidthBProtection,
    isOkUnderKeelClearance,
    minimumRevetmentThickness,
    minimumRevetmentWidthBProtection,
    resultPhysicalData,
    slopeAbscissaOfMaximumCurrentVelocityXvMax,
    underKeelClearance,
    vSlPilesMax,
    vSlopeMax,
    verticalDistanceBetweenThrusterAxisAndBedLevelHt,
} from '../../conversion/result';
import { selectProject } from '../../store/project/projectSlice';
import InfoIcon from '@mui/icons-material/Info';
import variable from '../../shared/style/variable';
import { InputLabel } from '@mui/material';

interface IResutProps {}

const Result = (props: IResutProps) => {
    const currentIndex = React.useContext(CurrentScenarioContext);

    const { t } = useTranslation();

    const project = useAppSelector(selectProject);
    const result = useAppSelector(selectResult);

    const handleTextTooltip = (name: string, value: any) => {
        if (name == verticalDistanceBetweenThrusterAxisAndBedLevelHt) return t('verticalDistanceBetweenThrusterAxisAndBedLevelHtInfo');
        if (name == horizontalDistanceBetweenPropellerAxisAndTheSlope) return t('horizontalDistanceBetweenPropellerAxisAndTheSlopeInfo');
        if (name == slopeAbscissaOfMaximumCurrentVelocityXvMax) return t('slopeAbscissaOfMaximumCurrentVelocityXvMaxInfo');
        if (name == vSlopeMax) return t('vSlopeMaxInfo');
        if (name == vSlPilesMax) return t('vSlPilesMaxInfo');
    };

    return (
        <Stack variant='scrollable' style={{ overflowX: 'auto' }}>
            <Typography variant='subtitle2' paddingBottom={'0.5rem'}>
                {t('outputData')}
            </Typography>
            {Object.entries(result.data!).map(x => {
                if (Object.values(result.data![x[0] as TResult]![currentIndex]).some(x => x !== null && x !== false)) {
                    let isOk = !Object.values(result.data![x[0] as TResult]![currentIndex]).some(x => x === false);
                    return (
                        <Accordion disableGutters defaultExpanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1a-content' id='panel1a-header'>
                                <Typography style={{ color: isOk ? '' : variable.red }}>{t(x[0])}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TableContainer>
                                    <Table aria-label='simple table'>
                                        <TableBody>
                                            {Object.entries(result.data![x[0] as TResult]![currentIndex])
                                                .filter(x => typeof x[1] !== 'boolean')
                                                .map((y, i) => {
                                                    let isOk = true;
                                                    if (y[0] === underKeelClearance) {
                                                        isOk = result.data![x[0] as TResult]![currentIndex][isOkUnderKeelClearance];
                                                    } else if (y[0] === minimumRevetmentThickness) {
                                                        isOk = result.data![x[0] as TResult]![currentIndex][isOkMinimumRevetmentThickness];
                                                    } else if (y[0] === minimumRevetmentWidthBProtection) {
                                                        isOk = result.data![x[0] as TResult]![currentIndex][isOkMinimumRevetmentWidthBProtection];
                                                    }
                                                    return (
                                                        <TableRow style={{ border: isOk ? '' : `3px solid ${variable.red}` }} key={y[0]} variant={i % 2 === 0 ? 'greenLight' : 'white'}>
                                                            <TableCell component='th' scope='row'>
                                                                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                                                                    <InputLabel style={{ fontSize: '0.8rem', color: isOk ? (i % 2 === 0 ? variable.greenLight : variable.black) : variable.red }}>
                                                                        {t(y[0], {
                                                                            unitOfMeasure: resultPhysicalData[y[0] as TResultPhysicalData].unitOfMeasure[project.data!.project!.unitOfMeasure!],
                                                                        })}
                                                                    </InputLabel>
                                                                    {handleTextTooltip(y[0], '') && (
                                                                        <Tooltip title={handleTextTooltip(y[0], '')}>
                                                                            <InfoIcon style={{ fill: variable.green }} fontSize='medium' />
                                                                        </Tooltip>
                                                                    )}
                                                                </Stack>
                                                            </TableCell>
                                                            <TableCell style={{ color: isOk ? '' : variable.red }} align='right'>
                                                                {y[1] ?? '-'}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                    );
                }
            })}
        </Stack>
    );
};

export default Result;
